import script from "./filter-criteria-stocks.vue?vue&type=script&setup=true&lang=js"
export * from "./filter-criteria-stocks.vue?vue&type=script&setup=true&lang=js"

import "./filter-criteria-stocks.vue?vue&type=style&index=0&id=1c540ce8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c540ce8"]])

export default __exports__